import { render, staticRenderFns } from "./internalctrl.vue?vue&type=template&id=0d011a62&scoped=true&lang=pug"
import script from "./internalctrl.vue?vue&type=script&lang=ts"
export * from "./internalctrl.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d011a62",
  null
  
)

export default component.exports